import store from '@/store'


export default () => {


  return ({
    status,
    body
  }) => {

    if (status === 401) {
      store.dispatch('snackbar/ActionSetSnackbar', {
        color: "error",
        text: "Não foi possível fazer login!",
        timeout: 2000
      })
      store.dispatch('auth/ActionSignOut')
      window._Vue.$router.push({
        name: 'login'
      })
    }
    if (status === 500) {
      store.dispatch('auth/ActionSignOut')
      // window._Vue.$router.push({
      //   name: 'login'
      // })
      // store.dispatch('snackbar/ActionSetSnackbar', {
      //   color: "error",
      //   text: "Erro de comunicaçao com o servidor!",
      //   timeout: 2000
      // })
    }
    if (status === 404) {
      store.dispatch('snackbar/ActionSetSnackbar', {
        color: "error",
        text: "Login ou senha inválido!",
        timeout: 2000
      })
    }
    if (status === 400) {
      store.dispatch('snackbar/ActionSetSnackbar', {
        color: "error",
        text: body,
        timeout: 4000
      })
    }
  }
}